import {backAdmin} from "../axios";

export const marketingApi = [
    {url: `${backAdmin}/marketing/currencies`, name: 'marketing.currencies', method: 'GET'},
    {url: `${backAdmin}/marketing/packages`, name: 'packages.all', method: 'GET'},
    {url: `${backAdmin}/marketing/packages`, name: 'packages.create', method: 'POST'},
    {url: `${backAdmin}/marketing/packages/{id}`, name: 'package.delete', method: 'DELETE'},
    {url: `${backAdmin}/marketing/packages/{id}`, name: 'package.update', method: 'PUT'},

    {url: `${backAdmin}/marketing/plans`, name: 'plans.all', method: 'GET'},
    {url: `${backAdmin}/marketing/plans/attributes`, name: 'plans.attributes', method: 'GET'},
    {url: `${backAdmin}/marketing/plans`, name: 'plan.create', method: 'POST'},
    {url: `${backAdmin}/marketing/plans/{id}`, name: 'plan.delete', method: 'DELETE'},
    {url: `${backAdmin}/marketing/plans/{id}`, name: 'plan.update', method: 'PUT'},

]